// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2-FMX","requiredAsterisk":"Info_requiredAsterisk__2QMAg"};